"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("react");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var react_2 = require("@emotion/react");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var rgba_1 = __importDefault(require("polished/lib/color/rgba"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var AccordionIcon = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\ttransition: transform 5s;\n\ttransform: rotate(0deg);\n\t-o-transition: transform 0.3s;\n\t-ms-transition: transform 0.3s;\n\t-moz-transition: transform 0.3s;\n\t-webkit-transition: transform 0.3s;\n\tdisplay: inline-block;\n\ttransition: transform 0.3s;\n\t@media print {\n\t\tdisplay: none !important;\n\t}\n"])));

var AccordionTab = function AccordionTab(_ref) {
  var _ref$circled = _ref.circled,
      circled = _ref$circled === void 0 ? false : _ref$circled,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      tabIndex = _ref.tabIndex,
      header = _ref.header,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return false;
  } : _ref$onClick,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "line" : _ref$variant,
      tabRef = _ref.tabRef,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? "2000px" : _ref$maxHeight,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      dataTabId = _ref.dataTabId,
      tabHeaderRef = _ref.tabHeaderRef,
      _ref$numberIcon = _ref.numberIcon,
      numberIcon = _ref$numberIcon === void 0 ? "" : _ref$numberIcon,
      _ref$isLastAccordionT = _ref.isLastAccordionTab,
      isLastAccordionTab = _ref$isLastAccordionT === void 0 ? true : _ref$isLastAccordionT,
      _ref$onOpen = _ref.onOpen,
      onOpen = _ref$onOpen === void 0 ? function () {} : _ref$onOpen,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      _ref$urlHash = _ref.urlHash,
      urlHash = _ref$urlHash === void 0 ? "" : _ref$urlHash;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, react_1.useState)(expanded),
      _ref4 = _slicedToArray(_ref3, 2),
      _isExpanded = _ref4[0],
      setIsExpanded = _ref4[1];

  var _ref5 = (0, react_1.useState)("0"),
      _ref6 = _slicedToArray(_ref5, 2),
      containerMaxHeight = _ref6[0],
      setContainerMaxHeight = _ref6[1];

  var containerRef = (0, react_1.createRef)();
  var headerColor = theme.colors[type].header;
  var borderColor = (0, rgba_1.default)(theme.colors[type].text, type === "tertiary" ? 0.2 : 0.5);
  var appearUnclickable = !multiple && _isExpanded;
  (0, react_1.useLayoutEffect)(function () {
    var ref = containerRef.current;

    if (ref) {
      setContainerMaxHeight(_isExpanded ? maxHeight : "0");
    }
  }, [_isExpanded]);

  var handleOnClick = function handleOnClick(id) {
    if (onClick(id)) {
      _isExpanded ? onClose(tabRef) : onOpen(tabRef);
      setIsExpanded(!_isExpanded);
    }
  };

  (0, react_1.useImperativeHandle)(tabRef, function () {
    return {
      open: function open() {
        setIsExpanded(true);
        onOpen(tabRef);
      },
      close: function close() {
        setIsExpanded(false);
        onClose(tabRef);
      },
      isExpanded: function isExpanded() {
        return _isExpanded;
      },
      containerRef: containerRef
    };
  });
  var borderStyle = "";

  if (_isExpanded || isLastAccordionTab) {
    borderStyle = "border-bottom: 1px solid ".concat(borderColor);
  }

  var boxTabHeader = (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\tbackground-color: inherit;\n\t\tcolor: ", ";\n\t\tcursor: ", ";\n\t\tpadding: 20px;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder: none;\n\t\toutline: none;\n\t\tborder-left: 1px solid ", ";\n\t\tborder-right: 1px solid ", ";\n\t\tborder-top: 1px solid ", ";\n\t\tborder-radius: 3px;\n\t\t", ";\n\t\t@media print {\n\t\t\tbackground-color: transparent !important;\n\t\t\tcolor: #000000 !important;\n\t\t\tborder: none !important;\n\t\t}\n\t"])), headerColor, appearUnclickable ? "inherit" : "pointer", borderColor, borderColor, borderColor, borderStyle);
  var boxTabContent = (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\tbackground-color: inherit;\n\t\tpadding: 0;\n\t\theight: \"auto\";\n\t\tmax-height: ", ";\n\t\toverflow: hidden;\n\t\t-o-transition: max-height 0.3s ease-in-out;\n\t\t-ms-transition: max-height 0.3s ease-in-out;\n\t\t-moz-transition: max-height 0.3s ease-in-out;\n\t\t-webkit-transition: max-height 0.3s ease-in-out;\n\t\ttransition: max-height 0.3s ease-in-out;\n\t\tborder-radius: 4px;\n\t\t@media print {\n\t\t\tbackground-color: transparent !important;\n\t\t\tcolor: #000000 !important;\n\t\t\tborder: none !important;\n\t\t\tmax-height: unset !important;\n\t\t\theight: auto !important;\n\t\t}\n\t"])), maxHeight);
  var lineTabHeader = (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\tbackground-color: inherit;\n\t\tcolor: ", ";\n\t\tborder-top: ", ";\n\t\tborder-bottom: ", ";\n\t\tcursor: ", ";\n\t\tpadding: 20px 0;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\toutline: none;\n\t\ttext-align: left;\n\t\ttransition: 0.4s;\n\t\t@media print {\n\t\t\tbackground-color: transparent !important;\n\t\t\tcolor: #000000 !important;\n\t\t\ttransition: none !important;\n\t\t}\n\t"])), headerColor, tabIndex === 0 ? "none" : "1px solid ".concat(borderColor), _isExpanded ? "1px solid ".concat(theme.colors.primary.primaryBrand) : "none", appearUnclickable ? "inherit" : "pointer");
  var lineTabContent = (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\tpadding: 0;\n\t\tbackground-color: inherit;\n\t\theight: \"auto\";\n\t\tmax-height: ", ";\n\t\toverflow: hidden;\n\t\t-o-transition: max-height 0.3s ease-in-out;\n\t\t-ms-transition: max-height 0.3s ease-in-out;\n\t\t-moz-transition: max-height 0.3s ease-in-out;\n\t\t-webkit-transition: max-height 0.3s ease-in-out;\n\t\ttransition: max-height 0.3s ease-in-out;\n\t\t@media print {\n\t\t\tbackground-color: transparent !important;\n\t\t\tcolor: #000000 !important;\n\t\t\theight: auto !important;\n\t\t\tmax-height: unset !important;\n\t\t\ttransition: none !important;\n\t\t}\n\t"])), maxHeight); // Create the header and content styles based on the variant property

  var tabHeader = (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t", ";\n\t"])), variant === "box" ? boxTabHeader : lineTabHeader);
  var tabContent = (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t", ";\n\t\tmargin: 0 auto;\n\t"])), variant === "box" ? boxTabContent : lineTabContent);
  var CircledNumber = styled_1.default.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t\tborder-radius: 50%;\n\t\tdisplay: inline-block;\n\t\theight: 20px;\n\t\twidth: 20px;\n\t\tline-height: 20px;\n\t\tmargin-right: 10px;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t"])), theme.colors.primary.primaryBrand, theme.colors.primary.white);
  return (0, jsx_runtime_1.jsxs)("div", {
    "data-tab-id": dataTabId,
    children: [(0, jsx_runtime_1.jsxs)("div", {
      css: tabHeader,
      onClick: function onClick() {
        return handleOnClick(tabIndex);
      },
      ref: tabHeaderRef,
      children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: size === "hd" ? "md" : size,
        weight: "bold",
        color: headerColor,
        variant: size === "hd" ? "h3" : "span",
        children: header
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        alignItems: "center",
        children: [numberIcon ? (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          variant: "span",
          size: "xs",
          children: (0, jsx_runtime_1.jsx)(CircledNumber, {
            children: numberIcon
          })
        }) : "", (0, jsx_runtime_1.jsx)(AccordionIcon, {
          style: {
            transform: _isExpanded ? "rotate(0deg)" : "rotate(180deg)"
          },
          children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: "chevron-up",
            size: circled ? "md" : "xs",
            color: headerColor,
            circled: circled,
            css: (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tcursor: inherit;\n\t\t\t\t\t\t\t"]))),
            selected: _isExpanded,
            disabled: appearUnclickable
          })
        })]
      })]
    }), (0, jsx_runtime_1.jsx)("div", {
      ref: containerRef,
      css: tabContent,
      style: {
        maxHeight: containerMaxHeight
      },
      "data-expanded": _isExpanded ? "true" : "false",
      "data-url-hash": urlHash,
      children: children
    })]
  });
};

exports.default = AccordionTab;